import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { Formule } from 'src/app/models/formule';
import { User } from 'src/app/micro-services/user/models/user';

@Component({
  selector: 'app-some-infos',
  templateUrl: './some-infos.component.html',
  styleUrls: ['./some-infos.component.scss'],
})
export class SomeInfosComponent implements OnInit {


  mostProfitFormule: Formule;
  mostProfitFormuleName: String;
  mostUsedFormule: Formule;
  mostUsedFormuleName: String;
  totalIncome: number = 0;
  coachId: string;
  coach : User;
  users: any;
  numberOfUsers: number;
  clients: User[];
  
  constructor(
    private userService: UserService,
    private ApiProviderService: ApiProviderService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.coach = this.userService.getUser();
    if (this.coach) {
      this.coachId = this.coach.id;}
    this.incomeTotalCaclul();
    this.getMostProfiFormule();
    this.getMostUsedFormule();
    this.ApiProviderService.getUsersByCoach(this.coachId).subscribe(
      (res) => {
        this.users = res;
        this.numberOfUsers = this.users.length;
        this.getClientsByCoach();
      },
      (err) => {
        this.users = [];
      },);
  }


  incomeTotalCaclul() {
    this.ApiProviderService.getTotalProfit(this.coachId).subscribe(
      (res: any) => {
        this.totalIncome = res;
      },
      (err) => {
        return;
      },
    )
  }

  getMostProfiFormule() {
    this.ApiProviderService.getMostProfitFormule(this.coachId).subscribe(
      (res: any) => {
        if (res) {
          var profit = 0;
          res.forEach(element => {
            if (element.totalProfit > profit) {
              this.mostProfitFormuleName = element.nomFormule
            }


          });
        }

      },
      (err) => {
        return;
      },
    )
  }

  getMostUsedFormule() {
    this.ApiProviderService.getMostUsedFormule(this.coachId).subscribe(
      (res: any) => {

        this.mostUsedFormule = res;
        this.mostUsedFormuleName = this.mostUsedFormule.name
      },
      (err) => {
        return;
      },
    )
  }

  getClientsByCoach() {
    this.ApiProviderService.getUsersByCoach(this.coachId).subscribe(
      (res: any) => {
        this.clients = res;

      },
      (err) => {
        this.clients = [];
      },
    );
  }

  goToDashboardFinance() {
    this.router.navigate(['coach/dashboard-finance']);
  }

}
